import { Box, Icon, IconSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const headerColumnWidth = '321px';
export const columnWidth = '170px';

export const ModuleRowStyled = styled.tr`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    font-size: ${theme.fontSizes[200]};
    color: ${theme.colors.grey[1000]};
    font-weight: ${theme.fontWeights[600]};
    height: 44px;
  `}
`;
export const PermissionRowStyled = styled(ModuleRowStyled)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    font-weight: normal;
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
export const ToggleSwitchContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    width: 170px;
    height: 44px;
    border-right: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const ModuleEmptyItemStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    width: 170px;
    height: 44px;
    border-right: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.grey[100]};
  `}
`;
export const PermissionStyled = styled(Box).attrs({ p: { sm: '450' } })`
  ${({ theme }) =>
    css`
      height: 44px;
      width: ${headerColumnWidth};
      border-right: solid 1px ${theme.colors.grey[300]};
    `}
`;

export const StickyColumnStyled = styled.td`
  ${() =>
    css`
      position: sticky;
      top: 0;
      left: 0;
      width: ${headerColumnWidth};
      z-index: 1;
    `}
`;

export const ExpandCollapseIconStyled = styled(Icon).attrs({ size: IconSize.SMALL })`
  ${({ theme }) => css`
    margin-right: ${theme.spacings[450]};
    color: ${theme.colors.bechtel.blue[800]};
  `}
`;

export const ModuleStyled = styled(Box).attrs({
  p: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-right: solid 1px ${theme.colors.grey[400]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    cursor: pointer;
    width: 321px;
  `}
`;

export const MatrixItemContainerStyled = styled(Box).attrs({})`
  ${() => css`
    overflow-y: auto;
    height: 100vh;
  `}
`;
